module.exports = __webpack_public_path__ + "img/play-icon-filled.d7e6ab2c.svg";